import ProgressReview from 'assets/images/composition/progress-review.webp';
import React from 'react';
import styles from './WaitReviewSidebar.module.scss';

const WaitReviewSidebar: React.FC = () => {
  return (
    <div className={styles.WaitReview}>
      <h2>Competências</h2>
      <hr />
      <img alt="Icone Lupa em análise" src={ProgressReview} />
      <p className={styles.Subtitle}>A atividade está em fase de correção</p>
      <p className={styles.Text}>
        Sua atividade está sendo processada e logo os resultados estarão
        disponíveis. Aguarde só mais um pouco!
      </p>
    </div>
  );
};

export default WaitReviewSidebar;
